import React from 'react';
import { Img } from './styles';

export const URL_LOGO = 'https://kinebot-statics.s3.amazonaws.com/logo.png';

export const Logo: React.FC = () => (
	<Img data-testid="container-logo-id" preview={{ visible: false, mask: false }} src={URL_LOGO} />
);
